export enum InstallPromptOutcome {
  ACCEPTED = 'accepted',
  DISMISSED = 'dismissed',
}
